import Connector, { takeQuery } from '../../agent';
import types from './types';
import { push } from 'connected-react-router';
import {
  transformChemicalProductDatesToMoment,
  transformChemicalProductSdsFilesDatesToMoment,
} from '../../Dates';
import { chemicalProductsActions } from './index';
import { changesNotificationModalActions } from '../changesNotificationModal';
import { goToErrorPage } from '../../utils';

const saveChemProdProcess = data => {
  if (data.chemicalProduct)
    data.chemicalProduct = transformChemicalProductDatesToMoment(data.chemicalProduct);
  if (data.recipients) data.recipients.forEach(p => (p.cannotBeDeleted = true));
  return data;
};

const ChemicalProducts = {
  saveChemicalProduct: ({ saveDto }) => Connector.api.post('/chemicalProducts', saveDto),
  getInitialData: ({ isCreationMode }) =>
    Connector.api.get(`/chemicalProducts/getInitialData`, false, { isCreationMode }),
  getChemicalProduct: ({ id }) => Connector.api.get(`/chemicalProducts/${id}`),
  getChemicalProductSdsFiles: ({ id }) => Connector.api.get(`/chemicalProducts/sdsFiles/${id}`),
  getChemicalProductTitleDetails: ({ id }) =>
    Connector.api.get(`/chemicalProducts/titleDetails/${id}`),
  deleteChemicalProduct: ({ id }) => Connector.api.delete(`/chemicalProducts/${id}`),
};

const chemicalProductSagas = [
  takeQuery(types.SAVE_CHEMICAL_PRODUCT_OR_OPEN_CONFIRMATION_MODAL, {
    api: ChemicalProducts.saveChemicalProduct,
    process: saveChemProdProcess,
    notify: [
      ({ request, data }) =>
        !data.openConfirmationModal
          ? push(`/chemicalProducts/view/${data.chemicalProduct.id}`)
          : { type: '' },
    ],
    notifyFailure: [() => changesNotificationModalActions.toggle(false)],
  }),
  takeQuery(types.GET_CHEMICAL_PRODUCT_INITIAL_DATA, {
    api: ChemicalProducts.getInitialData,
    notifyFailure: [goToErrorPage],
  }),
  takeQuery(types.GET_CHEMICAL_PRODUCT, {
    api: ChemicalProducts.getChemicalProduct,
    process: transformChemicalProductDatesToMoment,
    notifyFailure: [goToErrorPage],
    notify: [() => chemicalProductsActions.stateChange()],
  }),
  takeQuery(types.GET_CHEMICAL_PRODUCT_SDS_FILES, {
    api: ChemicalProducts.getChemicalProductSdsFiles,
    process: transformChemicalProductSdsFilesDatesToMoment,
  }),
  takeQuery(types.GET_CHEMICAL_PRODUCT_TITLE_DETAILS, {
    api: ChemicalProducts.getChemicalProductTitleDetails,
    notifyFailure: [goToErrorPage],
  }),
  takeQuery(types.DELETE_CHEMICAL_PRODUCT, {
    api: ChemicalProducts.deleteChemicalProduct,
    notify: [
      ({ request }) =>
        request.params.redirect ? push(`/chemicalProducts/overview/entity`) : { type: '' },
    ],
  }),
];

export default chemicalProductSagas;
